import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function SwipeRushPrivacy() {
    useEffect(function () { window.scrollTo(0, 0); }, []);
    return (
        <div className={"swiperush-page"}>
            <div className={"swiperush-content legal-page"}>
                <div className={"legal-header"}>
                    <Link to={"/products/swiperush"} className={"back-link"}>&larr; Back to SwipeRush</Link>
                    <h1>Privacy Policy</h1>
                    <p className={"effective-date"}>Effective Date: March 15, 2026</p>
                </div>

                <section className={"legal-section"}>
                    <h2>1. Introduction</h2>
                    <p>
                        Welcome to SwipeRush ("we," "our," or "us"), a product of Nuevo Alture Tech Ventures LLP (NA Tech Ventures).
                        This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you
                        use our mobile application SwipeRush. Please read this privacy policy carefully.
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>2. Information We Collect</h2>
                    <h3>Personal Information</h3>
                    <p>We may collect the following information when you use SwipeRush:</p>
                    <ul>
                        <li>Display name or username</li>
                        <li>Email address (if you choose to sign in)</li>
                        <li>Profile picture (if provided)</li>
                    </ul>
                    <h3>Automatically Collected Information</h3>
                    <p>When you use our app, we may automatically collect:</p>
                    <ul>
                        <li>Device information (model, operating system, unique device identifiers)</li>
                        <li>Usage data (game scores, play time, in-app actions)</li>
                        <li>Log data (IP address, access times, app features accessed)</li>
                    </ul>
                </section>

                <section className={"legal-section"}>
                    <h2>3. How We Use Your Information</h2>
                    <p>We use the collected information to:</p>
                    <ul>
                        <li>Provide, operate, and maintain SwipeRush</li>
                        <li>Improve and personalize your gaming experience</li>
                        <li>Manage leaderboards and competitive features</li>
                        <li>Communicate with you about updates and promotions</li>
                        <li>Monitor and analyze usage patterns and trends</li>
                        <li>Detect and prevent fraud or technical issues</li>
                    </ul>
                </section>

                <section className={"legal-section"}>
                    <h2>4. Sharing of Information</h2>
                    <p>
                        We do not sell your personal information. We may share information with third-party service providers
                        who assist us in operating our app, conducting our business, or serving our users, so long as those
                        parties agree to keep this information confidential.
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>5. Data Security</h2>
                    <p>
                        We use administrative, technical, and physical security measures to protect your personal information.
                        While we have taken reasonable steps to secure the information you provide to us, please be aware that
                        no method of transmission over the Internet or electronic storage is 100% secure.
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>6. Children's Privacy</h2>
                    <p>
                        SwipeRush is not intended for children under the age of 13. We do not knowingly collect personal
                        information from children under 13. If we learn that we have collected personal information from a
                        child under 13, we will take steps to delete such information promptly.
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>7. Changes to This Policy</h2>
                    <p>
                        We may update this Privacy Policy from time to time. We will notify you of any changes by updating
                        the "Effective Date" at the top of this page. You are advised to review this Privacy Policy
                        periodically for any changes.
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>8. Contact Us</h2>
                    <p>
                        If you have any questions about this Privacy Policy, please contact us at:
                    </p>
                    <p><strong>Email:</strong> <a href="mailto:contact@nuevoalture.com">contact@nuevoalture.com</a></p>
                    <p><strong>Company:</strong> Nuevo Alture Tech Ventures LLP</p>
                </section>
            </div>
        </div>
    );
}

export default SwipeRushPrivacy;
